import * as rules from "LIB/validation/rules";
import { EXCHANGE_FEE } from "MODULES/OutgoingQuotes/constants";
import { validator } from "LIB/validate-this";
import { CORE_DUE_DAYS } from "MODULES/RepairOrders/constants";
import { SELLER_ID } from "MODULES/SalesOrders/constants";

export function validate(values) {
  return validator(values, form => {
    form
      .validate(EXCHANGE_FEE, CORE_DUE_DAYS, SELLER_ID)
      .satisfies(rules.required);
  });
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/CreateSecondExchange/validate.js